import { ApiResponse, err, getAxios, processError, res } from "./axios";

export const getUserTokens = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/tokens/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, "Error retrieving user tokens.")
    return err(message, status)
  }
}

export const getTokensPurchaseConfig = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/tokens/get-tokens-purchase-config/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, "Error retrieving user tokens.")
    return err(message, status)
  }
}

export const getUserCompanyTokens = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/tokens/all-user-company-tokens`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, "Error retrieving user company tokens.")
    return err(message, status)
  }
}